import { useRouter } from '../../../../common/hooks/useRouter';
import { useConfig } from '../../../../providers/config-provider';
import { useContent } from '../../../../providers/content/hook';
import { RegionProps, useRegion } from '../../../../providers/region-provider';
import { useUserProfile } from '../../../../providers/user-provider';
import { TyRegionMessages } from '../../../../types';
import { getTextFromHtml } from '../../../../utils/common';
import { getRegionsFromHeaderContent } from '../../../../utils/regionUtils';
import Dropdown from '../../../basic/dropdown';

interface RegionNavLinksProps {
  readonly regionMessages: TyRegionMessages;
}

export default function RegionNavLink({ regionMessages }: RegionNavLinksProps) {

  const { content } = useContent();
  const { userProfile } = useUserProfile();
  const { selectedRegion, setSelectedRegion } = useRegion() as RegionProps;
  const { config } = useConfig();
  const { navigate } = useRouter();
  // const regions = content?.header?.regions?.value;
  const regions = getRegionsFromHeaderContent(content);
  const mappingRules = config?.rules?.mappingRules;

  const onClickHandler = (region: string) => {
    const mappedRegion = mappingRules?.find(
      rule => rule?.regionCode?.toLocaleLowerCase() === region.toLocaleLowerCase()
    );
    setSelectedRegion(
      regions?.find(
        (reg: { key: any }) =>
          reg.key.toLocaleLowerCase() === mappedRegion?.regionCode.toLocaleLowerCase()
      )
    );
    navigate('', region);
  };

  return (
    <div className="flex justify-center items-center">
      <span className="text-sm text-white ">{getTextFromHtml(regionMessages?.title)}</span>
      <Dropdown
        id="regionDropdownDesktop"
        options={regions}
        clickHandler={onClickHandler}
        iconName="location"
        selected={selectedRegion}
        disabled={!!userProfile?.region}
        toolTipMessage={getTextFromHtml(regionMessages?.region_change_tooltip_msg)}
        color="text-white"
        dropdownName="Region"
      />
    </div>
  );
}
